import React, { Dispatch, SetStateAction } from "react";
import { Modal, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  openLogout: boolean;
  setOpenLogout: Dispatch<SetStateAction<boolean>>;
  handleLogout: () => void;
}

export default function LogoutModal({
  openLogout,
  setOpenLogout,
  handleLogout,
}: Props) {
  return (
    <Modal
      className="modal logout_modal"
      open={openLogout}
      onClose={() => setOpenLogout(false)}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          {/* Title */}
          <div className="modal_title" style={{ justifyContent: "center" }}>
            <h2>Are you sure you want to logout?</h2>
          </div>

          {/* Footer Buttons */}
          <div className="footer_btn_flex">
            <Button
              className="btn btn_grey"
              onClick={() => setOpenLogout(false)}
            >
              No
            </Button>

            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpenLogout(false);
                handleLogout();
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
